module.exports = __webpack_public_path__ + "static/media/flora.f739fd99.jpg";